import React from 'react';
import CottageForm from '../components/CottageForm';

const AddCottage = () => {
  return (
    <div>
              <CottageForm />
    </div>
  );
};

export default AddCottage;
